// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1_4Mw","colMaxWidth":"Table_colMaxWidth__18VjU"};